import { render, staticRenderFns } from "./onlineOrderBreakdown.vue?vue&type=template&id=c80b664a&scoped=true&"
import script from "./onlineOrderBreakdown.vue?vue&type=script&lang=js&"
export * from "./onlineOrderBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80b664a",
  null
  
)

component.options.__file = "onlineOrderBreakdown.vue"
export default component.exports